<template>
  <q-card style="width:1600px;max-width:90%;height: 900px;color:#000;font-family: blod;">
    <q-toolbar>
      <q-toolbar-title><span style="font-weight: 700;font-size: 18px;">献血者信息</span></q-toolbar-title>
      <q-btn flat round dense icon="close" v-close-popup />
    </q-toolbar>
    <q-card-section style="height: calc(100% - 50px);">
      <div class="card-content">
        <div class="left">
          <div class="top">
            <div class="title">
              <q-avatar rounded size="130px">
                <img v-if="userUrl" :src="userUrl">
                <img v-else src="~@/assets/default2.jpg">
              </q-avatar>
              <div class="info">
                <div v-if="donRecords.bloodGroup || donRecords.bloodGroup === 0 || donRecords.rh || donRecords.rh === 0" class="blood-group">
                  {{$enums.BloodGroup.getItemText(donRecords.bloodGroup)}} {{$enums.BloodRh.getItemText(donRecords.rh)}}
                </div>
              </div>
            </div>
            <div class="content-detail">
              <div style="font-size: 22px;"><span style="color:#2470FF;padding-right: 20px;font-size: 28px;">{{ donator.name }}</span>{{ calcAge(donator.birthday) }}（{{$enums.Sex.getItemText(donator.sex)}}）</div>
              <div>证件类型：{{ $enums.IdCardType.getItemText(donator.idCardType) }}</div>
              <div>证件号码：{{ donator.idCard }}</div>
              <div>出生年月：{{ donator.birthday }}</div>
              <div>国籍：{{ getItemText(Number(donRecords.nationality), 'nationalityList') }}</div>
              <div>民族：{{ $enums.Nation.getItemText(donator.nation) }}</div>
              <div>联系电话：{{ donator.tel }}</div>
              <div>职业：{{ getItemText(Number(donator.profession), 'occupationList') }}</div>
              <div>文化程度：{{ $enums.EducationDegree.getItemText(donator.educationDegree) }}</div>
            </div>
          </div>
          <div class="bottom">
            <div class="title" style="font-size: 18px;font-weight: 700;margin-bottom: 10px;">历史献血记录</div>
            <div class="bottom-content">
              <div v-if="historyList.length">
                <div v-for="(item, index) in historyList" :class="['content-item', {'active': index === activeIndex}]" :key="index" @click="showResult(item, index)">
                  <span class="point"></span>
                  <span>{{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm') }}</span>
                  <span>{{ $enums.BloodType.getItemText(item.bloodType) }}</span>
                  <span>距今{{ calcDaysAgo(item.createTime) }}天</span>
                </div>
              </div>
              <div v-else class="no-log">暂无记录</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="type === 'consult'" class="consult-content">
            <div class="title" style="font-size: 18px;font-weight: 700;margin-bottom: 10px;">
              征询信息
            </div>
            <div class="main-content">
              <div class="consult-top">
                <div class="consult-left">
                  <span>征询时间：{{ formatDate(consultDonation.createTime, 'YYYY-MM-DD HH:mm') }}</span>
                  <span>预约献血时间：{{ formatDate(donRecords.createTime, 'YYYY-MM-DD') }}</span>
                </div>
                <div class="consult-right">
                  <span style="background-color: rgb(147,210,243)">献血类型：{{ $enums.BloodType.getItemText(donRecords.bloodType) }}</span>
                  <span :style="{'background-color': consultDonation.result ? 'rgb(129,179,55)' : '#F76361'}">健康征询：{{ getItemText(consultDonation.result, 'consultList') }}</span>
                </div>
              </div>
              <div class="consult-bottom">
                <div class="bottom-content">
                  <div class="title" style="font-size: 16px;font-weight: 700;margin-bottom: 10px;">
                    献血前检查
                  </div>
                  <div style="display: flex;justify-content: space-between;border-bottom: 2px solid #ccc;padding: 10px;" class="bottom-top">
                    <span>体重：{{ donRecords.weight }} kg</span>
                    <span>身高：{{ donRecords.height }}cm</span>
                    <span>收缩压：{{ donRecords.systolicPressure }} mmHg</span>
                    <span>舒张压：{{ donRecords.diastolicPressure }} mmHg</span>
                    <span>心率：{{ donRecords.heartRate }} bpm</span>
                  </div>
                  <div class="consult-question">
                    <div class="question-item" v-for="(item, index) in questionList" :key="index">
                      <span style="line-height: 30px;font-size: 16px;">{{ index + 1 }}.{{ item.text }}</span>
                      <span style="color:green;margin-left: 20px">{{ item.answerText  }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="type === 'result'" class="result-content">
            <div class="result-list">
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">献血时间</span>
                  <span style="font-size: 16px">{{ formatDate(donRecords.collectTime, 'YYYY-MM-DD HH:mm') }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">{{ $enums.BloodType.getItemText(donRecords.bloodType) }}</span>
                  <span style="font-size: 16px">{{ donRecords.capacity }}{{ $enums.BloodUnit.getItemText(donRecords.unit) }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">地点</span>
                  <span style="font-size: 16px">{{ getItemText(donRecords.collectPointId, 'locationList') }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">征询结果</span>
                  <span style="font-size: 16px">{{ getItemText(consultDonation.result, 'consultList')}}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">初筛结果</span>
                  <span style="font-size: 16px">{{ donRecords.testConclusion === 1 ? '不合格' : (donRecords.testConclusion === 2 ? '合格' : '待检')}}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">检测结果</span>
                  <span style="font-size: 16px">{{ donRecords.testResult ? (donRecords.testResult === 2 ? '通过' : donRecords.testResult === 1 ? '不通过' : '') : $enums.TestResult.getItemText(donRecords.testResult) }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 18px;width: 50px;height: 50px;border-radius: 25px;background-color: rgb(189,49,36);color:#fff;text-align: center;line-height: 50px;" class="bloog-group"> {{$enums.BloodGroup.getItemText(donRecords.bloodGroup)}} {{$enums.BloodRh.getItemText(donRecords.rh)}}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">ALT</span>
                  <span style="font-size: 16px">{{ donRecords.transaminase || '待检' }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">HBV</span>
                  <span style="font-size: 16px">{{ $enums.PossFourTestResult.getItemText(donRecords.hbvResult) }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">HCV</span>
                  <span style="font-size: 16px">{{ $enums.PossFourTestResult.getItemText(donRecords.hcvResult) }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">HIV</span>
                  <span style="font-size: 16px">{{ $enums.PossFourTestResult.getItemText(donRecords.hivResult) }}</span>
                </div>
              </div>
              <div class="result-item">
                <div class="result-icon">
                  <img src="~@/assets/result.png" alt="">
                </div>
                <div class="result-info">
                  <span style="font-size: 16px;font-weight: 700;">TP</span>
                  <span style="font-size: 16px">{{ $enums.PossFourTestResult.getItemText(donRecords.tpResult) }}</span>
                </div>
              </div>
            </div>
            <div class="result-bottom">
              <span>献血编号：{{ donRecords.donNo }}</span>
              <span>检查时间：{{ donRecords.testTime }}</span>
              <span>检查人：{{ donRecords.testOperator }}</span>
            </div>
          </div>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import utils from '@/lib/utils'
export default {
  props: {
    type: {
      type: String
    },
    currentId: {
      type: String
    }
  },
  computed: {
    consultDonation () {
      return this.data.consultDonation
    },
    donRecords () {
      return this.data.donRecords
    },
    donator () {
      return this.data.donator
    },
    historyList () {
      return this.data.historyDonRecordsList
    }
  },
  data () {
    return {
      userUrl: '',
      data: {},
      locationList: [],
      nationalityList: [],
      occupationList: [],
      consultList: [
        { label: '待征询', value: 0 },
        { label: '征询通过', value: 1 },
        { label: '征询未通过', value: 2 }
      ],
      questionDic: [],
      activeIndex: null,
      historyLog: [],
      questionList: []
    }
  },
  async mounted () {
    await this.getOccupation()
    await this.getNationality()
    await this.getConsultDic()
    await this.getLocationList()
    await this.searchData()
  },
  methods: {
    async getNationality () {
      const nationalityResult = await this.$$api.bis.get('enumItem/getByType/nationality')
      this.nationalityList = nationalityResult.data.map(n => {
        return {
          label: n.text,
          value: n.value
        }
      })
    },
    async getOccupation () {
      const occupationResult = await this.$$api.bis.get('enumItem/getByType/occupation')
      this.occupationList = occupationResult.data.map(n => {
        return {
          label: n.text,
          value: n.value
        }
      })
    },
    async getLocationList () {
      const locationResult = await this.$$api.bis.get('collectPoint/pageEx?pageSize=999&pageNum=1&dataOwnerId=1')
      this.locationList = locationResult.data.data.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
    },
    calcDaysAgo (time) {
      return utils.calcDaysAgo(time)
    },
    calcAge (birthday) {
      return utils.calcAge(birthday)
    },
    async searchData (id) {
      const donatorId = id || this.currentId
      const result = await this.$$api.bis.request({
        methods: 'get',
        url: '/donator/getDonInfoByDonRecordId',
        params: {
          donRecordId: donatorId
        }
      })
      this.data = result.data
      this.initData()
    },
    getItemText (id, key) {
      const findItem = this[key].find(k => k.value === id)
      return findItem ? findItem.label : ''
    },
    formatDate (val, tmp) {
      return utils.formatDateTime(val, tmp)
    },
    initData () {
      this.initConsultQuestion()
      this.initImageUrl()
    },
    async initImageUrl () {
      const photoID = this.donator?.photoId
      if (photoID) {
        const result = await this.$$api.bis.get(`/fileInfo/preView/${photoID}`, { responseType: 'blob' })
        const blob = new Blob([result.data], { type: 'image/jpeg' })
        const url = window.URL.createObjectURL(blob)
        this.userUrl = url
      } else {
        this.userUrl = ''
      }
    },
    initConsultQuestion () {
      const questionAndAnswer = JSON.parse(this.data.consultDonation.fillInRecords)
      const questionArr = JSON.parse(JSON.stringify(this.questionDic))
      questionArr.map(item => {
        const findItem = questionAndAnswer.find(q => q.titleNo === item.titleNo)
        if (findItem) {
          item.answer = findItem.answer
        } else {
          item.answer = null
        }
        item.answerText = item.answer === 1 ? '否' : (item.answer === 0 ? '是' : '')
      })
      this.questionList = questionArr
    },
    showResult (item, index) {
      this.activeIndex = index
      this.searchData(item.id)
    },
    async getConsultDic () {
      this.questionDic = []
      const consultDic = await this.$$api.bis.get('consult/')
      consultDic.data.map(c => {
        c.children.map(item => {
          const str2 = item.text.indexOf('.')
          const text2 = item.text.substring(str2 + 1, item.text.length)
          item.text = `${c.text}${text2}`
        })
        this.questionDic = [...this.questionDic, ...c.children]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-content {
  height: 100%;
  padding: 0 10px 10px 10px;
  display: flex;
  .left {
    height: 100%;
    width: 26%;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    .top {
        padding: 15px;
        border-radius: 15px;
        border: 1px solid #ccc;
        box-shadow: 0 0 0.52vw 0 rgba(0, 0, 0, 0.2);
        flex: 1;
        margin-bottom: 10px;
        .title {
            display: flex;
            font-size: 26px;
            justify-content: space-between;
        }
        .info {
            margin-left: 10px;
            display: flex;
            align-items: center;
            .blood-group {
              line-height: 80px;
              text-align: center;
              width: 80px;
              height: 80px;
              background-color: rgb(189,49,36);
              color: #fff;
              border-radius: 40px;
              margin-right: 30px;
            }
        }
        .content-detail {
          font-size: 16px;
          margin-top: 20px;
          height: calc(100% - 150px);
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
        }
    }
    .bottom {
        padding: 10px;
        border-radius: 15px;
        border: 1px solid #ccc;
        box-shadow: 0 0 0.52vw 0 rgba(0, 0, 0, 0.2);
        height: 250px;
        overflow: hidden;
        .bottom-content {
          height: calc(100% - 50px);
          overflow-y: scroll;
          .content-item {
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin: 10px 0;
            span {
                margin-right: 12px;
            }
          }
          .point {
            background-color: #000;
            display: inline-block;
            width: 15px;
            height: 15px;
            border-radius: 15px;
          }
          .active {
            color: rgb(222,134,143);
            .point {
              background-color: rgb(222,134,143);
            }
          }
          .content-item:hover {
            background-color: rgba(0, 0, 0, 0.1);
            cursor: pointer;
          }
        }
    }
  }
  .right {
    flex: 1;
    padding: 10px;
    border-radius: 15px;
    border: 1px solid #ccc;
    box-shadow: 0 0 0.52vw 0 rgba(0, 0, 0, 0.2);
    .consult-content {
      height:calc(100% - 5px);
      overflow: hidden;
      .main-content {
        height: 100%;
        font-size: 16px;
        .consult-top {
         display: flex;
         justify-content: space-between;
         border-bottom: 2px solid #ccc;
         padding-bottom: 10px;
         .consult-left {
            span {
                margin-left: 20px;
            }
         }
         .consult-right {
            span {
              border-radius: 3px;
              padding: 3px 10px;
              background-color: #ccc;
              color: #fff;
              margin-right: 20px;
            }
         }
        }
        .consult-bottom {
          height: calc(100% - 73px);
          .bottom-content {
            padding: 10px 10px 20px 10px;
            overflow: hidden;
            height: calc(100% - 40px);
            margin: 20px;
            border: 1px solid #ccc;
            border-radius: 10px;
            .consult-question {
              padding: 20px;
              height: calc(100% - 70px);
              overflow-y: scroll;
              .question-item {
                border: 1px solid #eee;
                margin-bottom: -1px;
                padding: 10px;
                display: flex;
                justify-content: space-between;
              }
            }
          }
         }
      }
    }
    .result-content {
      position: relative;
      .result-list {
        padding: 20px;
        display: grid;
        grid-gap: 30px;  /* 每个网格之间的间距 */
        justify-content: space-evenly;  /* 均匀平铺 */
        grid-template-columns: repeat(3, 31%);
      }
      .result-item {
        padding: 10px;
        margin-bottom: 25px;
        border-radius: 10px;
        height: 130px;
        border: 1px solid #eee;
        box-shadow: 0 0 0.52vw 0 rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        .result-info {
          height: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 40px;
          margin-left: 20px;
        }
      }
      .result-bottom {
        font-size: 16px;
        width: 100%;
        display: flex;
        position: absolute;
        bottom: -10px;
        justify-content: flex-end;
        span {
            margin-right: 30px;
        }
      }
    }
  }
  .no-log {
    font-size: 16px;
    text-align: center;
    color: #999;
    margin-top: 30px;
  }
}
/**设置滚动条的样式**/
.c-menu-list::-webkit-scrollbar,
  .c-scroll-silver::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    position: absolute;
  }
  /**滚动槽**/
  .c-menu-list::-webkit-scrollbar-track,
  .c-scroll-silver::-webkit-scrollbar-track {
    background: rgba(0,0,0,0);
  }
  /**滚动条滑块**/
  .c-menu-list::-webkit-scrollbar-thumb,
  .c-scroll-silver::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: rgba(0,0,0,0.6);
      -webkit-box-shadow: inset 0 0 1px rgba(255,255,255,0.3);
      transform: translate(-3px,0);
  }
  .c-menu-list::-webkit-scrollbar-thumb:window-inactive,
  .c-scroll-silver::-webkit-scrollbar-thumb:window-inactive {
      background: rgba(0,0,0,0.4);
  }
  /**设置滚动条的样式**/
  *::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      position: absolute;
  }
  /**滚动槽**/
  *::-webkit-scrollbar-track {
    background: rgba(0,0,0,0);
  }
  /**滚动条滑块**/
  *::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: rgba(0,0,0,0.18);
      transform: translate(-3px,0);
  }
  *::-webkit-scrollbar-thumb:window-inactive {
      background: rgba(0,0,0,0.1);
  }
</style>
